<template>
	<h3
		class="configurator-additional-info"
		v-if="navigation && spine != null">
		Rugdikte:
		<strong>{{ spine }} mm</strong>
		<strong>{{ pageCount }} pag. <span v-if="allPageCounts.altered"> / {{ allPageCounts.file }} pdf-pag.</span></strong>
	</h3>
	<div class="cell" v-else-if="table && spine != null">
		<p class="configurator-overview__option"><strong>Rugdikte:</strong></p>
		<p class="configurator-overview__option-name">
			{{ spine }} mm
			<strong>{{ pageCount }} pag. <span v-if="allPageCounts.altered"> / {{ allPageCounts.file }} pdf-pag.</span></strong>
		</p>
	</div>
	<span v-else-if="inline && spine != null">
		Rugdikte: {{ spine }}mm,
	</span>
	<h3
		v-else-if="spine != null">
		Rugdikte:
		<span>
			{{ spine }} mm
			<strong>{{ pageCount }} pag. <span v-if="allPageCounts.altered"> / {{ allPageCounts.file }} pdf-pag.</span></strong>
		</span>
	</h3>
	<price-pages v-else-if="navigation"/>
</template>

<script>
import pricePages from "@/components/element/price-pages";

export default {
	name: "Spine",
	components: {
		pricePages
	},
	props: {
		table: {
			type: Boolean,
			default: false
		},
		navigation: {
			type: Boolean,
			default: false
		},
		inline: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		selectedOptions () {
			return this.$store.getters.getSelectedOptions;
		},
		selectedFormat () {
			return this.$store.getters.getSelectedFormat;
		},
		pageCount () {
			return this.$store.getters.getPageCount;
		},
		printSidesCount () {
			return this.$store.getters.getPrintSidesCount;
		},
		allPageCounts () {
			return this.$store.getters.getAllPageCounts;
		},
		spine () {
			let spine = 0;
			let hasHardOrSoftCover = true;

			const productType = {
				default: 0,
				hardCover: 1,
				softCover: 2,
				flatLying: 4,
				cartBoardbudget: 5,
				cartBoardPermium: 6
			};
			// Let op: wanneer vlakliggend hier bij komt moet er een extra berekening komen met basethickness 13

			const chunkType = {
				cover: 0,
				content: 1
			};

			const optionCategory = {
				default: 0,
				paper: 1,
				print: 2,
				finish: 3,
				material: 4
			};
			let paperSelected = false;

			for (let i in this.selectedOptions) {
				const selectedOption = this.selectedOptions[i];
				const productOptionGroup = this.selectedFormat.productOptionGroups[i];
				const hasSelectedPaperThickness = productOptionGroup
					&& productOptionGroup.optionCategory === optionCategory.paper
					&& productOptionGroup.chunkType === chunkType.content;
				const isThicknessForTwoPages =  this.selectedFormat.productType === productType.hardCover
					|| this.selectedFormat.productType === productType.softCover;

				if (selectedOption && hasSelectedPaperThickness) {
					var pageCount = Math.max(0, this.pageCount - 24);

					if (isThicknessForTwoPages) {
						pageCount /= 2;
					}

					spine += pageCount * selectedOption.sheetThickness;
				}

				if (productOptionGroup.optionCategory === optionCategory.paper) {
					paperSelected = true;
				}
			}

			if (this.selectedFormat.productType === productType.hardCover) {
				spine += 6;
			} else if (this.selectedFormat.productType === productType.softCover) {
				spine += 3;
			} else if (this.selectedFormat.productType === productType.flatLying) {
				spine += 9.5;
			} else if (this.selectedFormat.productType === productType.cartBoardbudget) {
				spine = (this.pageCount / 2 * 1.03) + 2;
			} else if (this.selectedFormat.productType === productType.cartBoardPermium) {
				spine = (((this.pageCount / 2) + 1) * 1.97) + 2;
			} else {
				return null;
			}

			if (this.selectedFormat.productType === productType.hardCover
				|| this.selectedFormat.productType === productType.flatLying) {
				const possibleBacks = {
					7: 8.7,
					10: 10.7,
					12: 13.7,
					14: 15.7,
					17: 18.7,
					20: 21.7,
					22: 23.7,
					24: 25.7,
					27: 28.7,
					30: 31.7,
					33: 34.7,
					36: 37.7,
					39: 40.7,
					42: 43.7,
					45: 46.7
				};

				const roundedSpine = Object.keys(possibleBacks)
					.find((key) => {
						return spine < possibleBacks[key];
					});

				if (roundedSpine) {
					spine = parseInt(roundedSpine);
				}
			}

			if (hasHardOrSoftCover && paperSelected) {
				return Math.ceil(spine);
			}

			return null;
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/element/spine.vue